import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import TextField from './TextField';
import SearchIcon from '../icon/SearchIcon';
import InputAdornment from '@mui/material/InputAdornment';

class SearchWithButton extends Component {
    render() {
        const { placeholder, className, searchKeyword } = this.props;

        return (
            <div className="search-field">
                <form onSubmit={this.onSearchSubmit}>
                    <TextField
                        placeholder={placeholder}
                        className={className}
                        type="search"
                        hiddenLabel
                        InputProps={{
                            disableUnderline: true,
                            endAdornment: (
                                <InputAdornment position="end">
                                    <div
                                        style={{backgroundColor: searchKeyword ? '#ffba81' : null}}
                                        role="button"
                                        className="input-adornment--end"
                                        onClick={this.onSearchSubmit}>
                                        <SearchIcon />
                                    </div>
                                </InputAdornment>
                            ),
                            inputProps: {
                                ref: this.onSearchFieldRef
                            }
                        }}
                        customvalue={searchKeyword}
                    />
                </form>
            </div>
        );
    }

    onSearchSubmit = e => {
        if (e) e.preventDefault();

        if (this.searchFieldInput) {
            let { onSearchSubmit } = this.props;
            if (onSearchSubmit) {
                onSearchSubmit(this.searchFieldInput.value);
            }
        }
    };

    onSearchFieldRef = input => {
        this.searchFieldInput = input;
    };
}

export default withStyles({})(SearchWithButton);
